import {postBodyService,getService} from "./base.service";
import config from "../config/application";

//url
const add = 'roleConcept/add';
const update = 'roleConcept/update';
const deleteUrl = 'roleConcept/delete';
const listConceptNotAssigned = 'roleConcept/searchConceptNotAssigned';
const listConceptAssigned = 'roleConcept/searchConceptAssigned';
const listRoleConceptsByRoleId = 'roleConcept/searchByRole'

class RoleConceptService {
    getRoleConcepts(user, hasPermission, roleId) {
        const url = `${config.data.configuration.roleConcept.url}${listRoleConceptsByRoleId}/${user}/${hasPermission}/${roleId}`;
        return getService(url);
    }
    getConceptsNotAssigned(roleId) {
        const url = `${config.data.configuration.roleConcept.url}${listConceptNotAssigned}/${roleId}`;
        return getService(url);
    }
    getConceptsAssigned(roleId) {
        const url = `${config.data.configuration.roleConcept.url}${listConceptAssigned}/${roleId}`;
        return getService(url);
    }
    saveRoleConcept(roleConcept) {
        const url = `${config.data.configuration.roleConcept.url}${add}`;
        return postBodyService(url,roleConcept);
    }
    updateRoleConcept(roleConcept) {
        const url = `${config.data.configuration.roleConcept.url}${update}`;
        return postBodyService(url,roleConcept);
    }
    deleteRoleConcept(lsRoleConcept) {
        const url = `${config.data.configuration.roleConcept.url}${deleteUrl}`;
        return postBodyService(url,lsRoleConcept);
    }
}
export default new RoleConceptService(); 